import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
  isLogin: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false,
  isLogin: false
}

export const login = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.FETCH_LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_LOGIN_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data,
        isLogin: true
      }
      case actionTypes.CLEAR_LOGIN_DATA:
        return {
          ...state,
          data: {},
          isLogin: false
        }
    default:
      return state;
  }
}
